"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TopLabelWrapper = exports.SubText = exports.OptionalOrRequiredLabel = exports.Label = exports.InputWrapper = exports.FlexIndicatorContainer = exports.FieldWrapper = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _coreMixins = require("@legacy-vfuk/core-mixins");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

/* eslint-disable max-len */
var FieldWrapper = _styledComponents["default"].div.withConfig({
  displayName: "FieldWrapperstyle__FieldWrapper",
  componentId: "sc-1exrao2-0"
})(function (props) {
  return (0, _styledComponents.css)(["width:100%;min-width:90px;max-width:300px;", " ", " ", ""], _coreMixins.respondTo.md((0, _styledComponents.css)(["max-width:700px;", ""], props.width === 'full' && (0, _styledComponents.css)(["max-width:100%;"]))), props.width === 'auto' && (0, _styledComponents.css)(["display:inline-block;width:auto;"]), props.width === 'full' && (0, _styledComponents.css)(["max-width:100%;"]));
});

exports.FieldWrapper = FieldWrapper;

var Label = _styledComponents["default"].label.withConfig({
  displayName: "FieldWrapperstyle__Label",
  componentId: "sc-1exrao2-1"
})(function (props) {
  return (0, _styledComponents.css)(["display:block;color:", ";", " ", ";font-weight:", ";", ""], props.theme.color.monochrome6["default"], props.state === 'disabled' && (0, _styledComponents.css)(["color:", ";"], props.theme.color.monochrome6.disabled), _coreMixins.typography.heading(1, false), props.theme.fontWeight[2], !props.showLabel && (0, _styledComponents.css)(["", ";"], (0, _coreMixins.srOnly)()));
});

exports.Label = Label;

var SubText = _styledComponents["default"].div.withConfig({
  displayName: "FieldWrapperstyle__SubText",
  componentId: "sc-1exrao2-2"
})(function (props) {
  return (0, _styledComponents.css)(["", ";", ""], _coreMixins.typography.paragraph(1, false), props.state === 'disabled' && (0, _styledComponents.css)(["color:", ";"], props.theme.color.monochrome6.disabled));
});

exports.SubText = SubText;

var InputWrapper = _styledComponents["default"].div.withConfig({
  displayName: "FieldWrapperstyle__InputWrapper",
  componentId: "sc-1exrao2-3"
})(function () {
  return (0, _styledComponents.css)(["position:relative;"]);
});

exports.InputWrapper = InputWrapper;

var OptionalOrRequiredLabel = _styledComponents["default"].div.withConfig({
  displayName: "FieldWrapperstyle__OptionalOrRequiredLabel",
  componentId: "sc-1exrao2-4"
})(function () {
  return (0, _styledComponents.css)(["", ""], _coreMixins.typography.paragraph(1, false));
});

exports.OptionalOrRequiredLabel = OptionalOrRequiredLabel;

var FlexIndicatorContainer = _styledComponents["default"].div.withConfig({
  displayName: "FieldWrapperstyle__FlexIndicatorContainer",
  componentId: "sc-1exrao2-5"
})(function (props) {
  return (0, _styledComponents.css)(["display:flex;justify-content:space-between;flex-direction:row;flex-wrap:nowrap;", ""], !props.showLabel && (0, _styledComponents.css)(["display:block;", ";"], (0, _coreMixins.srOnly)()));
});

exports.FlexIndicatorContainer = FlexIndicatorContainer;

var TopLabelWrapper = _styledComponents["default"].div.withConfig({
  displayName: "FieldWrapperstyle__TopLabelWrapper",
  componentId: "sc-1exrao2-6"
})(function (props) {
  return (0, _styledComponents.css)(["", ""], props.showLabel && (0, _styledComponents.css)(["", ";"], (0, _coreMixins.spacing)('margin-bottom', 2)));
});

exports.TopLabelWrapper = TopLabelWrapper;
//# sourceMappingURL=FieldWrapper.style.js.map